import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DEFAULT_IMAGE = "https://assets.auxodev.dk/assets/512cb13c-28f0-4ecb-9d9d-4ac03cf77200/danske-seks-faggrupper-indsats.png";
const SITE_NAME = "Tak For Din Indsats";

function updateOrCreateMeta(selector, attributeName, attributeValue, content) {
  if (typeof document === 'undefined') return;
  let element = document.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attributeName, attributeValue);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

function updateOrCreateLink(rel, href) {
  if (typeof document === 'undefined') return;
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
}

export default function SEO({ title, description, ogImage = DEFAULT_IMAGE, canonical }) {
  const location = useLocation();

  const formattedTitle = title
    ? (title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`)
    : `${SITE_NAME} | Støtte til Danmarks frontpersonale`;

  const fallbackDescription = "Tak For Din Indsats (TFDI) er en frivillig forening, der yder et trygt sikkerhedsnet, rådgivning, peer-to-peer mentorordning og støtte til Danmarks frontpersonale i forsvar, politi, sundhed, brand og redning.";
  const finalDescription = description || fallbackDescription;

  useEffect(() => {
    // 1. Set document title
    document.title = formattedTitle;

    // 2. Set standard meta description
    updateOrCreateMeta('meta[name="description"]', 'name', 'description', finalDescription);

    // 3. Open Graph
    updateOrCreateMeta('meta[property="og:title"]', 'property', 'og:title', formattedTitle);
    updateOrCreateMeta('meta[property="og:description"]', 'property', 'og:description', finalDescription);
    updateOrCreateMeta('meta[property="og:image"]', 'property', 'og:image', ogImage);
    updateOrCreateMeta('meta[property="og:url"]', 'property', 'og:url', window.location.href);

    // 4. Twitter Card
    updateOrCreateMeta('meta[name="twitter:title"]', 'name', 'twitter:title', formattedTitle);
    updateOrCreateMeta('meta[name="twitter:description"]', 'name', 'twitter:description', finalDescription);
    updateOrCreateMeta('meta[name="twitter:image"]', 'name', 'twitter:image', ogImage);

    // 5. Canonical link
    const canonicalHref = canonical || window.location.origin + location.pathname;
    updateOrCreateLink('canonical', canonicalHref);
  }, [formattedTitle, finalDescription, ogImage, canonical, location.pathname]);

  return (
    <>
      <title>{formattedTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta property="og:title" content={formattedTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:title" content={formattedTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={ogImage} />
    </>
  );
}
